import Nango from '@nangohq/frontend';

import useToast, { ToastType } from './useToast';

import { nextTrpc } from '~/trpc';

const NANGO_URL = process.env.NANGO_URL || '';

// Custom hook for Nango connection logic
const useNangoConnect = ({
  onSuccess = () => {},
  onClose
}: {
  onClose?: () => void;
  onSuccess?: (data: unknown) => void;
}) => {
  const { enqueueToast } = useToast();

  // Initialize Nango client
  const nangoClient = new Nango({
    host: NANGO_URL
  });

  const { data: nangoSessionData } = nextTrpc.nango.getSessionToken.useQuery(
    undefined,
    {
      onError: (error) => {
        console.error('Failed to get Nango session token:', error);
        enqueueToast({
          message: 'Unable to retrieve integration session.',
          type: ToastType.ERROR
        });
      }
    }
  );
  const { token: accessToken } = nangoSessionData || {};

  const connectNango = () => {
    try {
      // Get the user's JWT token for authentication
      if (!accessToken) {
        console.error('No access token available for Nango connection');
        enqueueToast({
          message: 'Unable to retrieve Nango session token.',
          type: ToastType.ERROR
        });
        return;
      }
      // Open the connect UI
      const connectUI = nangoClient.openConnectUI({
        apiURL: NANGO_URL,
        onEvent: (event) => {
          try {
            if (event.type === 'close' && onClose) {
              onClose();
            }
            if (event.type === 'connect') {
              onSuccess(event.payload);
            }
          } catch (error) {
            console.error('Failed to send connection event:', error);
            enqueueToast({
              message: 'Unable to connect integration.',
              type: ToastType.ERROR
            });
          }
        }
      });

      // Set the session token
      connectUI.setSessionToken(accessToken);
    } catch (error) {
      console.error('Error connecting to integrations:', error);
      enqueueToast({
        message: 'Integration connection unavailable.',
        type: ToastType.ERROR
      });
    }
  };

  return {
    connectNango
  };
};

export default useNangoConnect;
